import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ErrorIcon extends BaseIcon {
  getChildren = () => [ <path fill={ this.getColor() }
                              fillRule='evenodd'
                              d='M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,12H7V10H9ZM9,9H7V3H9Z'/> ]
  getViewBox = () => '0 0 16 16'
}
